var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3332 13.9998C27.3332 21.3636 21.3636 27.3332 13.9998 27.3332C6.63604 27.3332 0.666504 21.3636 0.666504 13.9998C0.666504 6.63604 6.63604 0.666504 13.9998 0.666504C21.3636 0.666504 27.3332 6.63604 27.3332 13.9998ZM19.3736 9.9594C19.7641 10.3499 19.7641 10.9831 19.3736 11.3736L12.7069 18.0402C12.3164 18.4308 11.6833 18.4308 11.2927 18.0402L8.62606 15.3736C8.23554 14.983 8.23554 14.35 8.62606 13.9594C9.01658 13.5689 9.64976 13.5689 10.0403 13.9594L11.9998 15.9189L14.9796 12.9392L17.9594 9.9594C18.35 9.56888 18.983 9.56888 19.3736 9.9594Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/Check_circle.ad94ae7e61d9cbabb85ffd2cf604efe4.svg";
export { ForwardRef as ReactComponent };